module.exports = __webpack_public_path__ + "img/企业VIP.366f1249.png";